export const orderConfirmFormSections = {
  title: 'Адрес доставки',
  fields: [
    { id: 'country', inputName: 'country', label: 'Страна доставки' },
    { id: 'region', inputName: 'region', label: 'Регион доставки' },
    { id: 'city', inputName: 'city', label: 'Город доставки' },
    { id: 'street', inputName: 'street', label: 'Улица доставки' },
    { id: 'house', inputName: 'house', label: 'Дом доставки' },
    { id: 'apartment', inputName: 'apartment', label: 'Офис доставки' },
    { id: 'postcode', inputName: 'postcode', label: 'Почтовый индекс доставки' },
  ],
};
